import { useGetGroupsQuery } from "./groupsApiSlice"
import Group from "./Group"
import useAuth from "../../hooks/useAuth"
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link, useParams } from "react-router-dom"
import { faAdd } from "@fortawesome/free-solid-svg-icons"

const GroupsList = () => {
    useTitle('techGroups: Groups List')
    const {groupId, type} = useParams()
    const { username, isManager, isAdmin } = useAuth()

    const {
        data: groups,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetGroupsQuery('groupsList', {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content = <p className="errmsg">{error?.data?.message}</p>
    }

    if (isSuccess) {
        const { ids, entities } = groups

      

        const tableContent = ids.map(groupId => <Group key={groupId} groupId={groupId} />)

        content = (
            <>
                    <Link to={`/${type}/${groupId}/groups/new`}>
 <FontAwesomeIcon icon={faAdd} />הוספת קבוצה
        </Link>
            <table className="table table--groups">
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th group__name">שם</th>
                        <th scope="col" className="table__th group__company">חברה</th>
                        <th scope="col" className="table__th group__year">שנה</th>
                        <th scope="col" className="table__th group__archive">ארכיון</th>
                        <th scope="col" className="table__th group__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default GroupsList